import { API } from '@/src/api/api'
import { queryClient } from '@/src/api/queryClient'
import { queryKeys } from '@/src/api/queryKeys'
import type { StrategyControllerFetchStrategyOverviewsResponse } from '@/src/api/types/procurement'
import { type Query, useQuery } from '@tanstack/react-query'

interface UseStrategyOverviewsConfig {
  refetchInterval?: (
    query: Query<
      StrategyControllerFetchStrategyOverviewsResponse,
      Error,
      StrategyControllerFetchStrategyOverviewsResponse,
      ['procurement', 'strategies', 'fetchStrategyOverviews', ...string[]]
    >
  ) => number | false
  refetchOnMount?: boolean
}

export const useStrategyOverviews = (companyId: string, { refetchInterval, refetchOnMount = false }: UseStrategyOverviewsConfig = {}) => {
  return useQuery({
    queryKey: queryKeys.procurement.strategies.fetchStrategyOverviews.toKeyWithArgs(companyId),
    queryFn: () => API.procurements.fetchStrategyOverviews({ companyId }),
    enabled: !!companyId,
    refetchInterval,
    refetchOnMount: refetchOnMount ? 'always' : undefined,
  })
}

export const invalidateStrategyOverviewsQueries = () =>
  queryClient.invalidateQueries({
    queryKey: queryKeys.procurement.strategies.fetchStrategyOverviews.toKey(),
  })
